import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import * as crypto from 'crypto-js'; // Asegúrate de tener crypto-js instalado
import * as _ from 'lodash';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { SecurityService } from 'src/app/shared/services/security.service';
import Swal from 'sweetalert2';
import { RecepcionPedidosModalResultComponent } from './modal-result/modal-result.component';
import { RecepcionPedidosModalVerPedidoComponent } from './modal-ver-pedido/modal-ver-pedido.component';
export class RecepcionPedidosComponent {
    constructor(accesolocalstorage, clog, fb, rutService, messageRendererService, toastrService, formValidatorsService, vendedorService, pedidoService, datesService, fileDownloadService, http) {
        this.accesolocalstorage = accesolocalstorage;
        this.clog = clog;
        this.fb = fb;
        this.rutService = rutService;
        this.messageRendererService = messageRendererService;
        this.toastrService = toastrService;
        this.formValidatorsService = formValidatorsService;
        this.vendedorService = vendedorService;
        this.pedidoService = pedidoService;
        this.datesService = datesService;
        this.fileDownloadService = fileDownloadService;
        this.http = http;
        // Constants
        this.RB_TIPO_VISTA_RESUMEN = '_RB_TIPO_VISTA_RESUMEN_';
        this.RB_TIPO_VISTA_DETALLE = '_RB_TIPO_VISTA_DETALLE_';
        this.uploadedFiles = new Set(); // Almacena los hashes de archivos subidos
        this.currentPayload = null;
        this.listaDocumentos = null;
        this.resumenlistaDocumentos = null;
        this.listaDocumentosAll = null;
        this.resumenlistaDocumentosAll = null;
        this.paginationContext = new PaginationContext();
        this.resumen_paginationContext = new PaginationContext();
        this.detalle_paginationContext = new PaginationContext();
        this.optionsVendedores = [];
        this.areSelected = false;
        this.loading = false;
        this.processing = false;
        this.botonConvertir = true;
        this.CheckBoxAllValue = false;
        this.document = [];
        this.listSelectDoc = [];
        this.resumen_loading = false;
        this.contieneProductosDesactivados = true;
        this.mensajeMostrado = null;
        this.fileName = '';
        this.fileHash = '';
        this.log = this.clog.log('RECEPCION-PEDIDOS');
    }
    ngOnInit() {
        this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
        this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
        this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
        this.resumen_paginationContext.RecordsByPage = 10;
        this.detalle_paginationContext.RecordsByPage = 10;
        this.createForm();
        this.loadVendedores();
    }
    loadVendedores() {
        this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            const { registros } = respuesta;
            // this.optionsVendedores = registros.map((vendedor) => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }));
            var cantPedidos;
            cantPedidos = yield this.ObtenerPedidosVendedor();
            //** SI EL VENDEDOR CONTIENE PEDIDOS SE AGREGA A REGISTROS */
            registros.map((vendedor) => {
                cantPedidos.forEach((vend) => {
                    if (vendedor.codigo == vend.vendedor_codigo) {
                        if (vend.cantidad > 0) {
                            vendedor.cantPedidos = vend.cantidad;
                        }
                        else {
                            vendedor.cantPedidos = 0;
                        }
                    }
                });
            });
            //TODO: SI SE AGREGA CONDICION ELSE -> VENDEDOR.CODIGO NO ES IGUAL A VENDEDOR.VENDEDOR_CODIGO SE PISARA LA CANTIDAD GUARDADA ANTERIORMENTE
            //** SE REALIZA MAPEO APARTE - SI LA CANTIDAD DE PEDIDOS ES MAYOR A  0 SE MANTIENE LA CANTIDAD DE PEDIDOS SINO
            //* LA CANTIDAD DE PEDIDOS ES 0.*/
            registros.map((pedidos) => {
                if (pedidos.cantPedidos > 0)
                    pedidos.cantPedidos;
                else
                    pedidos.cantPedidos = 0;
            });
            this.optionsVendedores = registros.map((v) => (Object.assign({ value: v.codigo, label: '[' + v.cantPedidos + '] - ' + v.nombre }, v)));
        }));
    }
    ObtenerPedidosVendedor() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const a = yield new Promise((resolve) => {
                // Simulamos una operación asincrónica con setTimeout
                setTimeout(() => {
                    const inputParams = {
                        empresa_rut: this.rutEmpresa,
                        sucursal_codigo: this.sucursalEmpresa,
                        fecha_desde: this.formData.get('fechaDesde').value,
                        fecha_hasta: this.formData.get('fechaHasta').value,
                    };
                    this.vendedorService.obtenerActivosSegunFecha(inputParams, ({ mensajes, respuesta }) => {
                        const ok = respuesta !== null;
                        if (!ok) {
                            this.messageRendererService.showErrors(mensajes);
                            return;
                        }
                        const { registros } = respuesta;
                        console.log('Terminando función externa');
                        resolve(registros);
                    });
                }, 1000);
            });
            return yield Promise.resolve(a);
        });
    }
    UpdateVendedorPorFecha() {
        this.loadVendedores();
    }
    createForm() {
        const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
        this.formData = this.fb.group({
            tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
            fechaDesde: [initDate, [Validators.required]],
            fechaHasta: [currentDate, [Validators.required]],
            vendedores: [[]],
        });
    }
    buscar(currentPage) {
        this.resumenBuscar(currentPage);
        this.detalleBuscar(currentPage);
    }
    /********* RESUMEN *********/
    resumenBuscar(currentPage) {
        this.formValidatorsService.validateAllFormFields(this.formData);
        if (!this.formData.valid)
            return;
        this.resumen_paginationContext.CurrentPage = currentPage;
        this.resumenlistaDocumentos = null;
        this.resumenlistaDocumentosAll = null;
        const { fechaDesde, fechaHasta, vendedores } = this.formData.value;
        const inputParams = {
            entidad: {
                empresa_rut: this.rutEmpresa,
                sucursal_codigo: this.sucursalEmpresa,
                vendSel: vendedores,
                fecha_desde: fechaDesde,
                fecha_hasta: fechaHasta,
            },
            paginaActual: this.resumen_paginationContext.CurrentPage,
            cantidadRegistrosPorPagina: -1,
        };
        this.resumen_currentPayload = inputParams;
        this.log('inputParams', JSON.stringify(inputParams));
        this.resumen_loading = true;
        this.pedidoService.obtenerPedidos(inputParams, ({ mensajes, respuesta }) => {
            if (mensajes && mensajes.length > 0) {
                this.processing = false;
                this.messageRendererService.showInfoMessages(mensajes);
                this.messageRendererService.showErrors(mensajes);
                this.resumen_loading = false;
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            this.resumenlistaDocumentosAll = registros;
            this.resumen_paginationContext.RecordsCount = totalRegistros;
            this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage);
            this.resumen_paginationContext.CurrentPage = 1;
            this.resumenlistaDocumentosAll.map((pedido, index) => {
                pedido.additionalInfo = {};
                pedido.additionalInfo.rutFormato = this.rutService.AgregarDV(pedido.cliente_proveedor_rut);
                pedido.additionalInfo.index = index;
                pedido.additionalInfo.checked = true;
            });
            this.CheckBoxAllValue = true;
            this.areSelected = true;
            const inputParamsDesactivados = {
                empresa_rut: this.rutEmpresa,
                sucursal_codigo: this.sucursalEmpresa,
                vendSel: vendedores,
                fechaInicio: fechaDesde,
                fechaTermino: fechaHasta,
                paginaActual: 1,
                cantidadRegistrosPorPagina: -1,
            };
            this.obtenerPedidosDesactivados(inputParamsDesactivados);
            this.resumen_loading = false;
            this.showPageResumen(this.resumen_paginationContext.CurrentPage);
        });
    }
    obtenerPedidosDesactivados(inputParamsDesactivados) {
        this.pedidoService.obtenerPedidosDesactivados(inputParamsDesactivados, ({ mensajes, respuesta }) => {
            if (mensajes && mensajes.length > 0) {
                this.processing = false;
                this.messageRendererService.showInfoMessages(mensajes);
                this.messageRendererService.showErrors(mensajes);
                this.resumen_loading = false;
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            this.pedidosDesactivados = registros;
            this.resumenlistaDocumentosAll.forEach((element) => {
                this.pedidosDesactivados.map((x) => {
                    if (element.codigo == x.codigo) {
                        element.tieneproductosInactivos = x.tieneProductosInactivos;
                    }
                });
            });
            console.log(this.resumenlistaDocumentos, this.resumenlistaDocumentosAll);
        });
    }
    showPageResumen(pageNumber) {
        this.resumen_paginationContext.CurrentPage = pageNumber;
        const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage;
        this.resumenlistaDocumentos = _.slice(this.resumenlistaDocumentosAll, start, start + this.resumen_paginationContext.RecordsByPage);
    }
    resumenOnPageChange(context) {
        // this.resumenBuscar(context.RequestedPage)
        this.showPageResumen(context.RequestedPage);
    }
    /********* DETALLE *********/
    detalleBuscar(pageNumber) {
        // this.formValidatorsService.validateAllFormFields(this.formData);
        // if (!this.formData.valid)
        //   return
        this.detalle_paginationContext.CurrentPage = pageNumber;
        const vendSel = this.formData.get('vendedores').value.map((value) => ({ codigo: value }));
        const inputParams = {
            empresa_rut: this.rutEmpresa,
            sucursal_codigo: this.sucursalEmpresa,
            vendSel,
            fechaInicio: this.formData.get('fechaDesde').value,
            fechaTermino: this.formData.get('fechaHasta').value,
            paginaActual: this.detalle_paginationContext.CurrentPage,
            cantidadRegistrosPorPagina: -1,
        };
        this.currentPayload = inputParams;
        this.log('inputParams', JSON.stringify(inputParams));
        this.detalle_listaDocumentosAll = null;
        this.groupArr = null;
        this.pedidoService.obtenerPedidosDetalle(inputParams, ({ mensajes, respuesta }) => {
            if (mensajes && mensajes.length > 0) {
                this.processing = false;
                this.messageRendererService.showInfoMessages(mensajes);
                this.messageRendererService.showErrors(mensajes);
                this.loading = false;
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            if (registros.length > 0) {
                this.groupArr = registros.reduce((r, { codigo }) => {
                    if (!r.some((o) => o.codigo == codigo)) {
                        let totalSum = 0;
                        const totalNeto = registros.filter((v) => v.codigo === codigo);
                        const total_Pedidos = {
                            monto_total: _.sumBy(registros.filter((v) => v.codigo === codigo && v.producto_activo == true), 'monto_neto'),
                            total_iva: _.sumBy(registros.filter((v) => v.codigo === codigo && v.producto_activo == true), 'monto_total_iva'),
                            total_bruto: _.sumBy(registros.filter((v) => v.codigo === codigo && v.producto_activo == true), 'total_bruto'),
                            monto_descuento: _.sumBy(registros.filter((v) => v.codigo === codigo && v.producto_activo == true), 'monto_descuento'),
                        };
                        r.push({
                            codigo,
                            rutCliente: this.rutService.AgregarDV(registros.find((x) => x.codigo === codigo).cliente_proveedor_rut),
                            cliente_name: registros.find((x) => x.codigo === codigo).clienteNombre,
                            fecha_registro: registros.find((x) => x.codigo === codigo).fecha_registro,
                            direccion: registros.find((x) => x.codigo === codigo).direccion,
                            total_neto: total_Pedidos.monto_total,
                            total_iva: total_Pedidos.total_iva,
                            total_bruto: total_Pedidos.total_bruto,
                            total_descLineal: total_Pedidos.monto_descuento,
                            total_DescGbl: registros.find((x) => x.codigo === codigo).montoDescuentoGlobalTotal,
                            SubTotal: total_Pedidos.monto_total - registros.find((x) => x.codigo === codigo).montoDescuentoGlobalTotal,
                            index: codigo,
                            tieneProductosInactivos: registros.some((x) => x.codigo === codigo && x.producto_activo == false),
                            groupItem: registros.filter((v) => v.codigo == codigo),
                        });
                    }
                    return r;
                }, []);
                this.detalle_listaDocumentosAll = this.resumenlistaDocumentosAll;
                this.detalle_paginationContext.RecordsCount = this.groupArr.length;
                this.detalle_paginationContext.PagesCount = this.resumen_paginationContext.PagesCount;
                this.detalle_paginationContext.CurrentPage = 1;
            }
            if (this.groupArr) {
                this.groupArr.map((pedido, index) => {
                    pedido.additionalInfo = {};
                    pedido.additionalInfo.index = index;
                    pedido.additionalInfo.checked = true;
                });
            }
            this.CheckBoxAllValue = true;
            this.areSelected = true;
            this.loading = false;
            this.showPageDetalle(this.detalle_paginationContext.CurrentPage);
        });
    }
    showPageDetalle(pageNumber) {
        this.detalle_paginationContext.CurrentPage = pageNumber;
        const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage;
        this.listaDocumentos = _.slice(this.groupArr, start, start + this.detalle_paginationContext.RecordsByPage);
        console.log(this.listaDocumentos);
    }
    onPageChangeDetalle(context) {
        this.showPageDetalle(context.RequestedPage);
    }
    checkAllChange({ checked }) {
        //* VISTA DETALLADA
        this.groupArr.forEach((mov) => {
            mov.additionalInfo.checked = checked;
        });
        this.groupArr.forEach((mov) => (mov.additionalInfo.checked = checked));
        //* VISTA RESUMEN
        this.resumenlistaDocumentosAll.forEach((mov) => {
            mov.additionalInfo.checked = checked;
        });
        this.resumenlistaDocumentos.forEach((mov) => {
            mov.additionalInfo.checked = checked;
        });
        this.handleAreSelectedDetalle();
        this.handleAreSelected();
    }
    checkDetalle({ index }, { checked }) {
        //* VISTA DETALLADA
        if (this.formData.get('tipoVista').value === this.RB_TIPO_VISTA_DETALLE) {
            // const _indexAll = this.detalle_listaDocumentosAll.findIndex(p => p.codigo === index)
            const _indexAll = this.groupArr.findIndex((p) => p.additionalInfo.index === index);
            this.groupArr[_indexAll].additionalInfo.checked = checked;
            const _indexPage = this.listaDocumentos.findIndex((p) => p.additionalInfo.index === index);
            this.listaDocumentos[_indexPage].additionalInfo.checked = checked;
            //NOTE: LISTA DE DOCUMENTOS - (LOS PEDIDOS SE ENCUENTRAN DENTRO DE DETALLE_LISTADOCUMENTOSALL)
            this.listaDocumentos[_indexPage].additionalInfo.checked = checked;
            this.handleAreSelectedDetalle();
            const Cont = this.groupArr.filter((x) => x.additionalInfo.checked == true);
            if (Cont.length < this.groupArr.length) {
                this.CheckBoxAllValue = false;
            }
            else {
                this.CheckBoxAllValue = true;
            }
        }
        else {
            //* VISTA RESUMEN
            const _indexAll = this.resumenlistaDocumentosAll.findIndex((p) => p.additionalInfo.index === index);
            this.resumenlistaDocumentosAll[_indexAll].additionalInfo.checked = checked;
            const _indexPage = this.resumenlistaDocumentos.findIndex((p) => p.additionalInfo.index === index);
            this.resumenlistaDocumentos[_indexPage].additionalInfo.checked = checked;
            // this.groupArr[_indexAll].additionalInfo.checked = checked
            this.handleAreSelected();
            const Cont = this.resumenlistaDocumentos.filter((x) => x.additionalInfo.checked == true);
            if (Cont.length < this.resumenlistaDocumentos.length) {
                this.CheckBoxAllValue = false;
            }
            else {
                this.CheckBoxAllValue = true;
            }
        }
    }
    removeElementTypename(register) {
        delete register.__typename;
        return register;
    }
    handleAreSelected() {
        if (!this.resumenlistaDocumentosAll || this.resumenlistaDocumentosAll.length == 0)
            this.areSelected = false;
        this.areSelected = this.resumenlistaDocumentosAll.filter((mov) => mov.additionalInfo.checked).length > 0;
    }
    handleAreSelectedDetalle() {
        if (!this.groupArr || this.groupArr.length == 0)
            this.areSelected = false;
        this.areSelected = this.groupArr.filter((mov) => mov.additionalInfo.checked).length > 0;
    }
    loadPedido(codigo) {
        this.modalVerPedidoComponent.load(codigo);
    }
    showModalConvertirANotasResumen() {
        if (this.formData.get('tipoVista').value === this.RB_TIPO_VISTA_RESUMEN) {
            this.selected = this.resumenlistaDocumentosAll.filter((pedido) => pedido.additionalInfo.checked);
        }
        if (this.selected.length === 0) {
            this.toastrService.warning('Seleccione al menos un registro');
            return;
        }
        this.convertirNotasModal.show();
    }
    showModalConvertirANotasDetalle() {
        if (this.formData.get('tipoVista').value === this.RB_TIPO_VISTA_DETALLE) {
            this.selected = this.groupArr.filter((pedido) => pedido.additionalInfo.checked);
        }
        //*Mensaje Confirmación indicando que existen productos inactivos
        const ExistePedidoConInactivo = this.selected.some((x) => x.tieneProductosInactivos == true);
        if (ExistePedidoConInactivo) {
            this.mensajeMostrado = 'Existe pedido con producto(s) inactivos';
        }
        if (this.selected.length === 0) {
            this.toastrService.warning('Seleccione al menos un registro');
            return;
        }
        this.convertirNotasModal.show();
    }
    //*REALIZAR PROCESO PARA CONVERTIR A NOTA DE VENTA RESUMEN
    convertirANotasVentaResumen() {
        this.processing = true;
        const listaPedidosInputParams = [];
        this.listaPedidosSeleccionados = _.cloneDeep(this.resumenlistaDocumentosAll).filter((pedido) => pedido.additionalInfo.checked);
        for (let i = 0; i < this.listaPedidosSeleccionados.length; i++) {
            const pedido = this.listaPedidosSeleccionados[i];
            listaPedidosInputParams.push({ empresa_rut: this.rutEmpresa, codigo: pedido.codigo });
        }
        const inputParams = {
            rutEmpresa: this.rutEmpresa,
            sucursalCodigo: this.sucursalEmpresa,
            rutUsuario: this.rutUsuario,
            listaPedidos: listaPedidosInputParams,
        };
        this.log(JSON.stringify(inputParams));
        this.pedidoService.conviertePedidosEnNotaVenta(inputParams, ({ mensajes, respuesta }) => {
            if (mensajes && mensajes.length > 0) {
                this.processing = false;
                this.messageRendererService.showInfoMessages(mensajes);
                this.messageRendererService.showErrors(mensajes);
                // this.convertirNotasModal.hide()
                // return
            }
            this.modalVerResultadoComponent.show(respuesta);
            this.convertirNotasModal.hide();
            this.processing = false;
            if (respuesta.length > 0)
                this.buscar(1);
        });
    }
    //*REALIZAR PROCESO PARA CONVERTIR A NOTA DE VENTA DETALLE
    convertirANotasVentaDetalle() {
        this.processing = true;
        const listaPedidosInputParams = [];
        //*Informar que existen productos inactivos.
        this.listaPedidosSeleccionados = _.cloneDeep(this.groupArr).filter((pedido) => pedido.additionalInfo.checked);
        //*Enviar Pedidos solo activos y el total de solo los activos.
        for (let i = 0; i < this.listaPedidosSeleccionados.length; i++) {
            const pedido = this.listaPedidosSeleccionados[i];
            listaPedidosInputParams.push({ empresa_rut: this.rutEmpresa, codigo: pedido.codigo });
        }
        const inputParams = {
            rutEmpresa: this.rutEmpresa,
            sucursalCodigo: this.sucursalEmpresa,
            rutUsuario: this.rutUsuario,
            listaPedidos: listaPedidosInputParams,
        };
        this.log(JSON.stringify(inputParams));
        this.pedidoService.conviertePedidosEnNotaVenta(inputParams, ({ mensajes, respuesta }) => {
            if (mensajes && mensajes.length > 0) {
                this.processing = false;
                this.messageRendererService.showInfoMessages(mensajes);
                this.messageRendererService.showErrors(mensajes);
                // this.convertirNotasModal.hide()
                // return
            }
            this.modalVerResultadoComponent.show(respuesta);
            this.convertirNotasModal.hide();
            this.processing = false;
            if (respuesta.length > 0)
                this.buscar(1);
        });
    }
    onFileSelected(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const input = event.target;
            if (input.files && input.files.length > 0) {
                const file = input.files[0];
                this.fileName = file.name;
                // Mostrar confirmación con SweetAlert2
                const result = yield Swal.fire({
                    title: '¿Estás seguro?',
                    text: `Se subirá el archivo ${this.fileName}`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, subir',
                    cancelButtonText: 'Cancelar'
                });
                if (result.isConfirmed) {
                    const reader = new FileReader();
                    reader.onload = (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        const fileContent = e.target.result;
                        // Usar una expresión regular para extraer el JSON
                        const jsonMatch = fileContent.match(/\{.*\}$/);
                        this.fileHash = crypto.SHA256(fileContent + this.fileName).toString();
                        // Verificar si el hash ya existe en la base de datos
                        const exists = yield this.checkFileHash(this.fileHash);
                        if (exists) {
                            console.log('El archivo ya ha sido subido.');
                            this.toastrService.warning('Este archivo ya ha sido subido.');
                        }
                        else {
                            try {
                                if (jsonMatch) {
                                    const jsonData = JSON.parse(jsonMatch[0]); // Analiza el contenido JSON6
                                    this.generarPedidosDelArchivoJson(jsonData); // Envía el contenido JSON al servidor
                                }
                                else {
                                    throw new Error('No se encontró JSON válido en el archivo.');
                                }
                            }
                            catch (error) {
                                console.error('Error al analizar el archivo JSON:', error);
                                this.toastrService.error('Error al analizar el archivo JSON');
                            }
                        }
                    });
                    reader.readAsText(file);
                }
            }
            // Limpiar el valor del input para permitir la selección del mismo archivo
            input.value = '';
        });
    }
    checkFileHash(hash) {
        const inputParams = {
            entidad: {
                hash: hash,
                empresa_rut: this.rutEmpresa,
                usuario_rut_usuario: this.rutUsuario,
            }
        };
        return new Promise((resolve) => {
            this.pedidoService.verificarArchivo(inputParams, ({ mensajes, respuesta }) => {
                if (mensajes && mensajes.length > 0) {
                    this.messageRendererService.showErrors(mensajes);
                    resolve(false);
                }
                resolve(!!respuesta);
            });
        });
    }
    generarPedidosDelArchivoJson(jsonData) {
        // Cambiar las claves a "rutFormateado" y "sucursalNombre"
        jsonData.ForkListaPedido = jsonData.ForkListaPedido.map((pedido) => {
            const { RutFormateado, SucursalNombre, pedido_detalle } = pedido, rest = tslib_1.__rest(pedido, ["RutFormateado", "SucursalNombre", "pedido_detalle"]);
            // ✅ Formatear fecha_registro (de "21-04-2025 16:16:46" a "2025-04-21 16:16:46")
            const formatearFecha = (fecha) => {
                if (!fecha)
                    return fecha;
                const [dia, mes, anioHora] = fecha.split('-');
                if (!anioHora)
                    return fecha; // por si no viene con hora
                const [anio, hora] = anioHora.split(' ');
                return `${anio}-${mes}-${dia} ${hora}`;
            };
            // Arreglar campos vacíos en pedido_detalle
            const detallesNormalizados = pedido_detalle.map((detalle) => (Object.assign({}, detalle, { desc_tope: detalle.desc_tope === "" || detalle.desc_tope == null ? "0" : detalle.desc_tope, desc_lineal: detalle.desc_lineal === "" || detalle.desc_lineal == null ? "0" : detalle.desc_lineal })));
            return Object.assign({}, rest, { rutFormateado: RutFormateado, sucursalNombre: SucursalNombre, pedido_detalle: detallesNormalizados, fecha_registro: formatearFecha(pedido.fecha_registro), fecha_termino: formatearFecha(pedido.fecha_termino) });
        });
        const inputParams = {
            entidad: {
                forkListaPedido: jsonData.ForkListaPedido // Asegúrate de que jsonData tenga esta estructura
            }
        };
        try {
            this.pedidoService.generarPedidosDelArchivo(inputParams, ({ mensajes, respuesta }) => {
                //TODO: Manejar la respuesta del servidor
                if (!respuesta.exito || respuesta.error != null) {
                    console.error('Error al subir el archivo:', respuesta.mensaje);
                    this.toastrService.error(respuesta.error);
                    return;
                }
                //Guardar el hash del archivo en la base de datos
                this.saveFileHash(this.fileHash, this.fileName);
                this.buscar(1);
                return;
            });
        }
        catch (error) {
            console.error('Error al subir el archivo:', error);
            this.toastrService.error('Error al subir el archivo');
            return;
        }
    }
    saveFileHash(hash, fileName) {
        const inputParams = {
            entidad: {
                hash: hash,
                empresa_rut: this.rutEmpresa,
                rut_usuario: this.rutUsuario,
                nombre_archivo: fileName,
                fecha_creacion: new Date().toISOString().split('T')[0],
            }
        };
        try {
            this.pedidoService.guardarArchivo(inputParams, ({ mensajes, respuesta }) => {
                if (!respuesta) {
                    this.toastrService.error("Error al guardar el archivo");
                    return;
                }
                console.log('Archivo guardado con éxito:', respuesta);
                this.toastrService.success('Archivo subido con éxito');
                return;
            });
        }
        catch (error) {
            console.error('Error al guardar el archivo:', error);
            this.toastrService.error('Error al guardar el archivo');
            return;
        }
    }
    downloadExcelDetalle(type) {
        const inputParams = _.cloneDeep(this.currentPayload);
        inputParams.paginaActual = 1;
        inputParams.cantidadRegistrosPorPagina = -1;
        this.log('inputParams', JSON.stringify(inputParams));
        // QUERY OBTENER EXCEL DETALLE
        this.pedidoService.obtenerPedidosXLSDetalle(inputParams, ({ mensajes, respuesta }) => {
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            if (respuesta)
                this.fileDownloadService.VerifyAndDownload(respuesta);
        });
    }
    //* OBTENER EXCEL/PDF DE LA VISTA RESUMEN Y DETALLE */
    downloadExcelPdfResumen(type) {
        const inputParams = _.cloneDeep(this.resumen_currentPayload);
        inputParams.paginaActual = 1;
        inputParams.cantidadRegistrosPorPagina = -1;
        this.log('inputParams', JSON.stringify(inputParams));
        // Ajustar el formato de inputParams eliminando la propiedad 'entidad'
        const inputParamsSinEntidad = {
            empresa_rut: this.resumen_currentPayload.entidad.empresa_rut,
            sucursal_codigo: this.resumen_currentPayload.entidad.sucursal_codigo,
            vendSel: this.resumen_currentPayload.entidad.vendSel,
            fechaInicio: this.resumen_currentPayload.entidad.fecha_desde,
            fechaTermino: this.resumen_currentPayload.entidad.fecha_hasta,
            paginaActual: inputParams.paginaActual,
            cantidadRegistrosPorPagina: inputParams.cantidadRegistrosPorPagina
        };
        // QUERY OBTENER EXCEL RESUMEN
        this.pedidoService.obtenerPedidosXLSResumen(inputParamsSinEntidad, ({ mensajes, respuesta }) => {
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            if (respuesta)
                this.fileDownloadService.VerifyAndDownload(respuesta);
        });
    }
    //* ELIMINAR PEDIDO POR VISTA RESUMEN O VISTA DETALLE */
    eliminarPedido(ped) {
        this.tittle = 'Eliminar';
        this.message = '¿Está seguro de eliminar el pedido ' + ped.codigo + '?';
        this.modalConfirm.show(() => {
            this.eliminarPedidoAux(ped);
        });
    }
    eliminarPedidoAux(entidad) {
        const self = this;
        const inputParams = {
            entidad: {
                codigo: entidad.codigo,
                empresa_rut: entidad.empresa_rut,
            },
        };
        this.log('inputParams pedido ', JSON.stringify(inputParams));
        this.pedidoService.eliminar(inputParams, ({ mensajes, respuesta }) => {
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            self.toastrService.success('Operación exitosa');
            self.buscar(1);
        });
    }
    //* FIN ELIMINAR PEDIDO POR VISTA RESUMEN O VISTA DETALLE */
    limpiarBusqueda() {
        // Obtener fechas iniciales del mes
        const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
        // Resetear el formulario con fechas por defecto
        this.formData.reset({
            tipoVista: this.RB_TIPO_VISTA_RESUMEN,
            fechaDesde: initDate,
            fechaHasta: currentDate,
            vendedores: []
        });
        // Limpiar las listas de documentos
        this.listaDocumentos = null;
        this.resumenlistaDocumentos = null;
        this.listaDocumentosAll = null;
        this.resumenlistaDocumentosAll = null;
        this.groupArr = null;
        // Resetear estados
        this.areSelected = false;
        this.CheckBoxAllValue = false;
        this.fileName = '';
    }
}
